// extracted by mini-css-extract-plugin
export default {"container":"Rules_container__60FYu","depiction":"Rules_depiction__qE04T","description":"Rules_description__X0wyF"};